<template>
    <DxDataGrid ref="dataGridRef" :data-source="dsCategorii" key-expr="ID" :remote-operations="true"
        @selection-changed="onSelectionChanged" :focused-row-enabled="false" :selected-row-keys="selectedRowKeys"
        :onRowRemoving="onRowRemoving" :show-row-lines="true" :hover-state-enabled="true" :show-borders="true">
        <DxSelection mode="single" />
        <DxFilterRow :visible="true" />
        <DxPaging :page-size="20" :page-index="1" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxToolbar>
            <DxItem>
                <template #default>
                    <DxButton icon="add" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
        <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="600" :height="580">
                <DxToolbarItem :template="customTitleTemplate" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-span="1" :col-count="1" item-type="group">
                <DxItemForm data-field="Nume" :editor-options="{ width: 560 }" />
                <DxItemForm :col-span="2" :col-count="2" item-type="group">
                    <DxItemForm data-field="Cod" />
                    <DxItemForm data-field="JurnalCodInternId" editor-type="dxSelectBox" :editor-options="{
                        dataSource: dsCodIntern,
                        valueExpr: 'ID',
                        displayExpr: 'Cod',
                        placeholder: 'Selectează',
                    }" :label="{ text: 'Jurnal Cod Intern' }" />
                    <DxItemForm data-field="ClasaId" :visible="false" :editor-options="{
                        dataSource: dsClase,
                        displayExpr: 'Id',
                        valueExpr: 'ClasaID'
                    }" />
                    <DxItemForm data-field="WwwID" :editor-options="{ showSpinButtons: true }"
                        editor-type="dxNumberBox" />
                    <DxItemForm data-field="WwwSyncedDate" editor-type="dxDateBox"
                        :editor-options="{ type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm' }" />
                </DxItemForm>
                <DxItemForm data-field="CategorieContabilaDefaultId" editor-type="dxSelectBox" :editor-options="{
                    dataSource: dsCategoriiContabile,
                    valueExpr: 'Id',
                    displayExpr: 'Nume',
                    placeholder: 'Selectează',
                }" :label="{ text: 'Categorie Contabilă' }" />
                <DxItemForm :col-span="4" :col-count="4" item-type="group">
                    <DxItemForm data-field="Client" editor-type="dxSwitch" />
                    <DxItemForm data-field="Furnizor" editor-type="dxSwitch" />
                    <DxItemForm data-field="Editabil" editor-type="dxSwitch" />
                    <DxItemForm data-field="MateriePrima" editor-type="dxSwitch" />
                </DxItemForm>
                <DxItemForm data-field="Explicatie" :editor-options="{ width: 560, height: 100 }" />
            </DxFormGrid>
        </DxEditing>
        <DxColumn data-field="Cod" />
        <DxColumn data-field="Nume" />
        <DxColumn data-field="Client" />
        <DxColumn data-field="Furnizor" />
        <DxColumn data-field="Editabil" />
        <DxColumn data-field="CategorieContabilaDefaultId" caption="Categorie Contabilă" :lookup="{
            dataSource: dsCategoriiContabile,
            valueExpr: 'Id',
            displayExpr: 'Nume'
        }" />
        <DxColumn data-field="MateriePrima" />
        <DxColumn data-field="JurnalCodInternId" caption="Jurnal Cod Intern" :lookup="{
            dataSource: dsCodIntern,
            valueExpr: 'ID',
            displayExpr: 'Cod'
        }" />
        <DxColumn data-field="ClasaId" caption="Clasa" :lookup="{
            dataSource: dsClase,
            valueExpr: 'ID',
            displayExpr: 'NumeArborescent'
        }" />
        <DxColumn data-field="WwwID" :visible="false" />
        <DxColumn data-field="WwwSyncedDate" :visible="false" />
        <DxColumn data-field="Explicatie" :visible="false" />
    </DxDataGrid>
    <DxPopupAdd v-model:visible="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
        :width="600" :height="580">
        <template #title>
            <div
                style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold; padding: 10px; padding-left: 20px;">
                Adăugare
            </div>
        </template>
        <div>
            <DxForm>
                <DxItem data-field="Nume" :editor-options="{
                    value: formData.Nume,
                    onValueChanged: e => formData.Nume = e.value
                }" />

                <DxItem :col-span="2" :col-count="2" item-type="group">
                    <DxItem data-field="Cod" :editor-options="{
                        value: formData.Cod,
                        onValueChanged: e => formData.Cod = e.value
                    }" />

                    <DxItem data-field="JurnalCodInternId" editor-type="dxSelectBox" :editor-options="{
                        value: formData.JurnalCodInternId,
                        onValueChanged: e => formData.JurnalCodInternId = e.value,
                        dataSource: dsCodIntern,
                        valueExpr: 'ID',
                        displayExpr: 'Cod',
                        showClearButton: true,
                        placeholder: 'ex: Selectează'
                    }" :label="{ text: 'Jurnal Cod Intern' }" />
                    <DxItem data-field="ClasaId" :visible="false" :editor-options="{
                        dataSource: dsClase,
                        displayExpr: 'Id',
                        valueExpr: 'ClasaID'
                    }" />

                    <DxItem data-field="WwwID" :editor-options="{
                        showSpinButtons: true, value: formData.WwwID,
                        onValueChanged: e => formData.WwwID = e.value
                    }" editor-type="dxNumberBox" />
                    <DxItem data-field="WwwSyncedDate" editor-type="dxDateBox" :editor-options="{
                        type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm', value: formData.WwwSyncedDate,
                        onValueChanged: e => formData.WwwSyncedDate = e.value
                    }" />

                </DxItem>
                <DxItem data-field="CategorieContabilaDefaultId" editor-type="dxSelectBox" :editor-options="{
                    dataSource: dsCategoriiContabile,
                    valueExpr: 'Id',
                    displayExpr: 'Nume',
                    showClearButton: true,
                    width: 560,
                    placeholder: 'ex: Selectează',
                    value: formData.CategorieContabilaDefaultId,
                    onValueChanged: e => formData.CategorieContabilaDefaultId = e.value
                }" :label="{ text: 'Categorie Contabilă' }" />


                <DxItem :col-span="4" :col-count="4" item-type="group">
                    <DxItem data-field="Client" editor-type="dxSwitch" :editor-options="{
                        value: formData.Client,
                        onValueChanged: e => formData.Client = e.value
                    }" />
                    <DxItem data-field="Furnizor" editor-type="dxSwitch" :editor-options="{
                        value: formData.Furnizor,
                        onValueChanged: e => formData.Furnizor = e.value
                    }" />
                    <DxItem data-field="Editabil" editor-type="dxSwitch" :editor-options="{
                        value: formData.Editabil,
                        onValueChanged: e => formData.Editabil = e.value
                    }" />
                    <DxItem data-field="MateriePrima" editor-type="dxSwitch" :editor-options="{
                        value: formData.MateriePrima,
                        onValueChanged: e => formData.MateriePrima = e.value
                    }" />
                </DxItem>
                <DxItem data-field="Explicatie" :editor-options="{
                    width: 560, height: 100, value: formData.Explicatie,
                    onValueChanged: e => formData.Explicatie = e.value
                }" />

            </DxForm>
            <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top:25px;">
                <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
            </div>
        </div>
    </DxPopupAdd>
</template>
<script lang="ts">
import { defineComponent, ref, markRaw } from 'vue';
import { locale, loadMessages } from 'devextreme/localization';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,

} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { DxLookup } from 'devextreme-vue';
import PRO_Categorii from '@/services/PRO/PRO_Categorii';
export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxLookup
    },
    props: {
        ClasaID: String
    },
    watch: {
        ClasaID: {
            immediate: true,
            handler(newVal, oldVal) {
                if (newVal !== oldVal || oldVal === undefined) {
                    this.createODataContext(newVal);
                }
            }
        }
    },

    data() {
        return {
            dsCategorii: {} as ODataStore,
            dsCategoriiContabile: {} as ODataStore,
            dsCodIntern: {} as ODataStore,
            dsClase: {} as ODataStore,
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            isModalVisible: false,
            formData: {
                Cod: '',
                Nume: '',
                Client: false,
                Furnizor: false,
                Editabil: false,
                CategorieContabilaDefaultId: null,
                JurnalCodInternId: null,
                ClasaID: '',
                UserCreare: '',
                DataCreare: null,
                UserModificare: '',
                DataModificare: null,
                MateriePrima: false,
                WwwID: null,
                WwwSyncedDate: null,
                Explicatie: '',
            },
            dataGridRef: ref<DxDataGrid | null>(null),
            selectedRowKeys: [],
            suppressSelection: false,
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {
                return `
          <div style="background-color: #ff2c21; font-size: 15px; float: right; height:47px; width:665px; color: white; 
          font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
            Editare
          </div>
        `;
            },
        };
    },
    methods: {

        createODataContext(ClasaID) {

            const headers = () => ({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
            });
            this.dsCategorii = markRaw({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Categorii',
                    key: 'Id',
                    version: 4,
                    fieldTypes: { ClasaID: 'Guid', Id: 'Guid' },
                    beforeSend: e => {
                        e.headers = headers();
                        e.params.$expand = [
                            'CategorieContabilaDefault($select=Nume)',
                            'JurnalCodIntern($select=Cod)',
                            'Clasa($select=Nume)'
                        ];
                    },
                }),
                filter: ['ClasaID', '=', ClasaID]
            });


            this.dsCategoriiContabile = markRaw(new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CON_CategoriiContabile',
                key: 'Id',
                version: 4,
                beforeSend: e => { e.headers = headers(); }
            }));

            this.dsCodIntern = markRaw(new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'PRO_CodIntern',
                key: 'ID',
                version: 4,
                beforeSend: e => { e.headers = headers(); }
            }));

            this.dsClase = markRaw(new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'PRO_Clase',
                key: 'Id',
                version: 4,
                beforeSend: e => { e.headers = headers(); }
            }));
        },

        onAddClick() {
            this.formData = {
                Cod: '',
                Nume: '',
                Client: false,
                Furnizor: false,
                Editabil: false,
                CategorieContabilaDefaultId: null,
                JurnalCodInternId: null,
                ClasaID: '',
                UserCreare: '',
                DataCreare: null,
                UserModificare: '',
                DataModificare: null,
                MateriePrima: false,
                WwwID: null,
                WwwSyncedDate: null,
                Explicatie: '',
            };
            this.isModalVisible = true;
        },
        onSaveAdd() {
            this.formData.ClasaID = this.ClasaID;
            if (!this.formData.Nume || this.formData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }
            if (!this.formData.Cod || this.formData.Cod.trim() === '') {
                notify('Completați câmpul obligatoriu "Cod"!', 'error', 1000);
                return;
            }
            const body = this.formData;
            PRO_Categorii.save(body).then(() => {
                this.isModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);
                this.formData = {
                    Cod: '',
                    Nume: '',
                    Client: false,
                    Furnizor: false,
                    Editabil: false,
                    CategorieContabilaDefaultId: null,
                    JurnalCodInternId: null,
                    ClasaID: '',
                    UserCreare: '',
                    DataCreare: null,
                    UserModificare: '',
                    DataModificare: null,
                    MateriePrima: false,
                    WwwID: null,
                    WwwSyncedDate: null,
                    Explicatie: '',
                };
                this.createODataContext(this.ClasaID);
            }).catch((error) => {
                console.error(error);
                notify('Datele exista deja!', 'error', 1000);
            });

        },
        onCancel() {
            this.isModalVisible = false;
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext(this.ClasaID);
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onSaveEdit() {
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            savePromise
                .then(() => {
                    notify('Datele au fost salvate cu succes!', 'success', 1000);
                })
                .catch((error) => {
                    notify('Eroare la salvarea datelor!', 'error', 1000);
                });

            //this.createODataContext(this.ClasaID);
        },
        onCancelEdit() {
            this.$refs.dataGridRef.instance?.cancelEditData();
        },
        onRowRemoving(e) {
            e.cancel = new Promise((resolve) => {
                //this.dataGridRef?.instance?.saveEditData();
                notify('Datele au fost șterse cu succes!', 'success', 1000);
                resolve(false);
            });
        },
        onSelectionChanged(e) {
            const row = e.selectedRowsData?.[0]
            if (row?.Id) {
                this.$router.push({ name: 'Produse', query: { CategorieId: row.Id } })
            }
        },

    },

    mounted() {
        this.createODataContext();
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');

    },
});
</script>
<style scoped lang="scss"></style>